// Import Packages
import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

// Import Helper
import { CheckIfFlowUpdated } from "../../../../helpers/helper";

// Import Material UI
import { Select, MenuItem, Box } from "@material-ui/core";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControl from "@material-ui/core/FormControl";
import Radio from "@material-ui/core/Radio";

// Import Pages
import { TextInput } from "../../../FlowConfigurationInputs/TextInput/NewTextInput";
import { CredentialPicker } from "../../../FlowConfigurationInputs/CredentialPicker/CredentialPicker";
import FieldLabel from '../../../FlowConfigurationInputs/FieldLabel/FieldLabel';

// Import Recoil
import { changedFields, initialActions, saveAvailable } from "../../../../recoil-store/recoil-state";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import {timeZones} from "../../../../home/pages/automs/autom/leftSideBar/variables/timeZones/TimeZones";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import {makeStyles} from "@material-ui/core/styles";

function TabPanel({ children, value, index }) {
  return <div>{value === index && <Box>{children}</Box>}</div>;
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

const useStyles = makeStyles((theme) => ({
  formControl: {
    minWidth: 120,
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
  option: {
    '& > span': {
      marginRight: 10,
      fontSize: 12,
    },
    fontSize: 13,
    fontWeight: 600,
    color: '#46474E',
  },
  inputRoot: {
    "& fieldset": {
      borderColor: '#E6E6E6',
      borderWidth: '1.1px'
    }
  },
  popupIndicator: {
    color: "#B0B0B0",
    height: "10px",
    width: "10px"
  }
}));

function Connect({ action, variables, setOpenVariable }) {
  const { t } = useTranslation();
  const label = "CONTENT.CONFIGURATION-FORM.DATABASE.CONNECT.";
  const [databaseType, setDatabaseType] = useState(
    !action.fields?.databaseType?.value && "mssql"
  );
  const [value, setValue] = useState("tns");
  const [radioButtonValue, setRadioButtonValue] = useState("sname");
  const initialActionsData = useRecoilValue(initialActions);
  const setSaveAvailable = useSetRecoilState(saveAvailable);
  const [changedFieldsState, setChangeFields] = useRecoilState(changedFields);
  const [selectedTimeZone, setSelectedTimeZone] = useState({});

  const classes = useStyles();

  useEffect(() => {
    if (!action.fields.instanceType) {
      action.fields.instanceType = { value: "" };
    } else {
      if (action.fields.instanceType.value.length > 1) setValue(action.fields.instanceType.value);
      if (action.fields.instanceType.value === "direct") {
        if (action.fields.serviceName) {
          setRadioButtonValue("sname");
        } else {
          setRadioButtonValue("sid");
        }
      }
    }
    if (!action.fields.databaseType || action.fields.databaseType?.value === '') {
      action.fields.databaseType = { value: "mssql" };
    } else {
      if (action.fields.databaseType.value.length > 1) {
        setDatabaseType(action.fields.databaseType.value);
        if (action.fields.databaseType.value === "mysql") {
          if (action.fields) {
            delete action.fields.instanceName;
            delete action.fields.systemId;
            delete action.fields.serviceName;
            delete action.fields.timeZone;
            delete action.fields.tns;
            delete action.fields.instanceType;
          }
        } else if (action.fields.databaseType.value === "mssql") {
          if (action.fields) {
            delete action.fields.port;
            delete action.fields.systemId;
            delete action.fields.serviceName;
            delete action.fields.timeZone;
            delete action.fields.tns;
            delete action.fields.instanceType;
          }
        } else if (action.fields.databaseType.value === "postgresql") {
          if (action.fields) {
            delete action.fields.port;
            delete action.fields.instanceName;
            delete action.fields.systemId;
            delete action.fields.serviceName;
            delete action.fields.timeZone;
            delete action.fields.tns;
            delete action.fields.instanceType;
          }
        } else if (action.fields.databaseType.value === "oracle") {
          if (action.fields) {
            delete action.fields.databaseName;
          }
        }
      }
    }
  }, [action]);

  const handleSelect = (event) => {
    if (event.target.value === "mysql") {
      setDatabaseType(event.target.value);
      action.fields.databaseType.value = event.target.value;
      if (action.fields) {
        delete action.fields.instanceName;
        delete action.fields.systemId;
        delete action.fields.serviceName;
        delete action.fields.timeZone;
        delete action.fields.tns;
        delete action.fields.instanceType;
      }
    } else if (event.target.value === "mssql") {
      setDatabaseType(event.target.value);
      action.fields.databaseType.value = event.target.value;
      if (action.fields) {
        delete action.fields.port;
        delete action.fields.systemId;
        delete action.fields.serviceName;
        delete action.fields.timeZone;
        delete action.fields.tns;
        delete action.fields.instanceType;
      }
    } else if (event.target.value === "postgresql") {
      setDatabaseType(event.target.value);
      action.fields.databaseType.value = event.target.value;
      if (action.fields) {
        delete action.fields.port;
        delete action.fields.instanceName;
        delete action.fields.systemId;
        delete action.fields.serviceName;
        delete action.fields.timeZone;
        delete action.fields.tns;
        delete action.fields.instanceType;
      }
    } else if (event.target.value === "oracle") {
      setDatabaseType(event.target.value);
      action.fields.databaseType.value = event.target.value;
      if (action.fields) {
        delete action.fields.databaseName;
      }
    }
    const field = initialActionsData[action.id]?.fields.databaseType;
    const oldValue = !field ? undefined : field.value;
    CheckIfFlowUpdated('action', action, oldValue, event.target.value, setSaveAvailable, setChangeFields, changedFieldsState);
  };

  // changed tabs panel
  const handleChange = (newValue) => {
    if (newValue === "tns" && action.fields) {
      delete action.fields.systemId;
      delete action.fields.serviceName;
    } else if (newValue === "direct" && action.fields) {
      delete action.fields.tns;
    }
    if (!action.fields.instanceType) {
      action.fields.instanceType = { value: newValue };
    } else {
      action.fields.instanceType.value = newValue;
    }
    setValue(newValue);
  };

  const handleRadioCheck = (event) => {
    if (event.target.value === "sid" && action.fields) {
      delete action.fields.serviceName;
    } else if (event.target.value === "sname" && action.fields) {
      delete action.fields.systemId;
    }
    setRadioButtonValue(event.target.value);
  };


  return (
    <div>
      <div className="conf-field-container">
        <FieldLabel name={t(label + "DATABASE-TYPE")} />
        <Select
          value={databaseType}
          onChange={(e) => handleSelect(e)}
          variant="outlined"
          fullWidth
          style={{ width: "90%" }}
        >
          <MenuItem value="mssql">Microsoft SQL Server</MenuItem>
          <MenuItem value="mysql">MySQL</MenuItem>
          <MenuItem value="postgresql">PostgreSQL</MenuItem>
          <MenuItem value="oracle">Oracle</MenuItem>
        </Select>
      </div>
      <div className="conf-field-container">
        <FieldLabel name={t(label + "SERVER-NAME")} is_required={true} />
        <TextInput
          action={action}
          inputName="serverName"
          variables={variables}
          setOpenVariable={setOpenVariable}
          isRequired
          hideRequired={true}
        />
      </div>
      {databaseType !== "oracle" && (
        <div className="conf-field-container">
          <FieldLabel name={t(label + "DATABASE-NAME")} is_required={true} />
          <TextInput
            action={action}
            inputName="databaseName"
            variables={variables}
            setOpenVariable={setOpenVariable}
            isRequired
            hideRequired={true}
          />
        </div>
      )}
      <div className="conf-field-container">
        <FieldLabel name={t(label + "USER")} is_required={true} />
        <CredentialPicker
          action={action}
          inputName="loginUser"
          variables={variables}
          setOpenVariable={setOpenVariable}
          isRequired={true}
          hideRequired={true}
        />
      </div>
      <div className="conf-field-container">
        <FieldLabel name={t(label + "PASSWORD")} is_required={true} />
        <CredentialPicker
          action={action}
          inputName="loginPassword"
          variables={variables}
          setOpenVariable={setOpenVariable}
          isRequired={true}
          isPassword={true}
          hideRequired={true}
        />
      </div>
      {(databaseType === "mysql" || databaseType === "oracle" || databaseType === "mssql") && (
        <div className="conf-field-container">
          <FieldLabel name={t(label + "PORT")} is_required={databaseType !== "mssql"} />
          <TextInput
            action={action}
            inputName="port"
            variables={variables}
            setOpenVariable={setOpenVariable}
            isRequired={databaseType !== "mssql"}
            hideRequired={databaseType !== "mssql"}
          />
        </div>
      )}
      {(databaseType === "oracle") && (
          <div className="conf-field-container">
            <FieldLabel name={t(label + "TIME-ZONE")}/>
            <TextInput
                action={action}
                inputName="timeZone"
                variables={variables}
                setOpenVariable={setOpenVariable}
            />
            <small className="conf-field-desc"><em>Ex: Europe/Berlin or UTC</em></small>
          </div>
      )}
      {databaseType === "mssql" && (
          <div className="conf-field-container">
          <FieldLabel name={t(label + "INSTANCE-NAME")} />
          <TextInput
            action={action}
            inputName="instanceName"
            variables={variables}
            setOpenVariable={setOpenVariable}
            isRequired={false}
          />
        </div>
      )}
      {databaseType === "oracle" && (
        <div className="conf-field-container">

          <FieldLabel name={`Oracle ${t(label + "INSTANCE-NAME")}`} />
          <div className="condition-tabs">
            <button
              className={`f-s-11 ${value === "tns" ? "condition-active" : ""}`}
              onClick={() => handleChange("tns")}
            >
              {t(label + "TNS")}
            </button>
            <button
              className={`f-s-11 ${value === "direct" ? "condition-active" : ""}`}
              onClick={() => handleChange("direct")}
            >
              {t(label + "DIRECT")}
            </button>
          </div>
          <TabPanel value={value} index="tns">
            <TextInput
              action={action}
              isRequired={false}
              inputName="tns"
              variables={variables}
              setOpenVariable={setOpenVariable}
            />
          </TabPanel>
          <TabPanel value={value} index="direct">
            <div className="conf-field-container">
              <FormControl component="fieldset">
                <RadioGroup
                  aria-label="gender"
                  name="direct"
                  value={radioButtonValue}
                  onChange={handleRadioCheck}
                >
                  <FormControlLabel
                    value="sname"
                    control={<Radio color="default" size="small" />}
                    label={t(label + "SERVICE-NAME")}
                  />
                  <FormControlLabel
                    value="sid"
                    control={<Radio color="default" size="small" />}
                    label={t(label + "SYSTEM-ID")}
                  />
                </RadioGroup>
              </FormControl>
              <TextInput
                action={action}
                inputName={
                  radioButtonValue === "sid" ? "systemId" : "serviceName"
                }
                variables={variables}
                setOpenVariable={setOpenVariable}
                isRequired={false}
              />
            </div>
          </TabPanel>
        </div>
      )}
    </div>
  );
}

export default Connect;